import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthProvider';
/**
 * Provides authenticated user info
 * @returns
 */
var useAuth = function () { return useContext(AuthContext); };
export default useAuth;
